import { render, staticRenderFns } from "./SurnameInput.vue?vue&type=template&id=029df17f&"
import script from "./SurnameInput.vue?vue&type=script&lang=ts&"
export * from "./SurnameInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports